import React, { createContext, useContext, useEffect, useState } from "react";
import { useKeycloak } from "@react-keycloak/web";

const AuthContext = createContext({ roles: [] });

export const AuthProvider = ({ children }) => {
  const { keycloak } = useKeycloak();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    if (keycloak?.tokenParsed) {
      setRoles(keycloak.tokenParsed.resource_access?.['dashboard-back']?.roles || []);
    }
  }, [keycloak.token, keycloak.tokenParsed]);

  return (
    <AuthContext.Provider value={{ roles }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
